'use strict';

angular.module('cvsApp')
  .factory("accountDataService", ['patientInfoService', 'accountBalanceService', 'retrieveFormOfPaymentService', 'getRXHistoryDetailsService', '$http', '$q', 'loggerService', 'addDataService', 'webAnalytics', 'loggerServiceHelper', '$rootScope', 'cvsAppData', '$cookies','$filter',
    function (PIS, ABS, RFOP, RXHDS, $http, $q, loggerService, addDataService, webAnalytics, loggerServiceHelper, $rootScope, CAD, $cookies, $filter) {

      //  Private variables
      var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.BALANCE));
      var _accountBalanceData = {};
      var _mopData = [];
      var _patientData = {};
      // var _paymentHistoryData = [];
      var _rxHistoryData = {};
      // var _paymentHistory = {};
      var paymentPending = true;
      var _paymentPending = false;
      var _achAuthorizationRequiredFlag = false;
      var _recentPaymentAmount = false;
      var _numRefills = 0;
      var _accountBalanceError = false;
      var _paymentHistoryError = false;
      var _retrievePatientInformationError = false;
      var _retrievePaymentInformationError = false;
      var _retrieveRxError = false;
      var _recentPaymentId;
      var _guestTokenID;
      var _retrieveCardExpiryError;
      var _primaryMethod;
      // var _pHistory = [];
      var _mopDataService;
      var componentName;
      var _refId;
      var _hideComponent = false;


      //  Define the public API
      return {

        get accountBalanceError() {
          return _accountBalanceError;
        },
        get primaryMethod() {
          if (_mopData) {
            var primaryMethod = _.filter(_mopData, {
              "primaryMethod": "true"
            });
            return primaryMethod[0];
          }
        },
        // get paymentHistoryError() {
        //   return _paymentHistoryError;
        // },
        get retrievePatientInformationError() {
          return _retrievePatientInformationError;
        },
        get retrievePaymentInformationError() {
          return _retrievePaymentInformationError;
        },
        get retrieveCardExpiryError() {
          return _retrieveCardExpiryError;
        },
        get retrieveRxError() {
          return _retrieveRxError;
        },
        get recentPaymentId() {
          return _recentPaymentId;
        },

        get guestTokenID() {
          return _guestTokenID;
        },
        //  List of User's addresses
        get addresses() {
          _patientData.getPatientAllAddress();
        },

        get accordantStatus() {
          return _patientData.getPatientInfo().patientAccordantStatus;
        },

        get banefitPlan() {
          return _patientData.getPatientInfo().benefitPlan;
        },

        //  Current Account Balance
        get currentBalance() {
          if (_accountBalanceData.getAcBal) {
            return parseFloat(_accountBalanceData.getAcBal());
          }
        },
        //  TODO: Remove this for PROD, only using this
        //  to dynamically configure the prototype version
        set currentBalance(b) {
          _accountBalanceData.accountBalance = b;
        },

        get negativeBalanceInd() {
          return _accountBalanceData.getAcBal && parseFloat(_accountBalanceData.getAcBal()) < 0 ? true : false;
        },
        get showAccountBalance() {
          if (_accountBalanceData.showView) {
            return _accountBalanceData.showView();
          }
          return true;
        },
        //  User's Date of Birth
        get dob() {
          return _patientData.getPatientInfo().dateOfBirth;
        },

        // User's full display name
        get firstName() {
          return _patientData.getPatientInfo().firstName;
        },

        // User's full display name
        get lastName() {
          return _patientData.getPatientInfo().lastName;
        },

        // User's full display name
        get fullName() {
          return _patientData.getPatientInfo().firstName + " " + _patientData.getPatientInfo().lastName;
        },

        //  List of user's medical conditions
        get medicalConditions() {
          return _patientData.getPatientInfo().patientsMedicalConditions;
        },

        //  Whether user has a achAuthorizationRequired
        get achAuthorizationRequiredFlag() {
          return _accountBalanceData.isACHAuthorizationRequired;
        },
        //  TODO: Remove this for PROD, only using this
        //  to dynamically configure the prototyep version
        set achAuthorizationRequiredFlag(p) {
          _achAuthorizationRequiredFlag = p;
        },

        get recentPaymentAmount() {
          return parseFloat(_accountBalanceData.recentPaymentAmount());
        },

        get hideComponent() {
          return _hideComponent;
        },


        set recentPaymentAmount(p) {
          _recentPaymentAmount = p;
        },

        get paymentPending() {
          if (_accountBalanceData && _accountBalanceData.isPaymentPending) {
            return _accountBalanceData.isPaymentPending();
          }
          return false;
        },
        //  TODO: Remove this for PROD, only using this
        //  to dynamically configure the prototyep version
        set paymentPending(p) {
          _paymentPending = p;
        },

        get achExpired() {
          if (_accountBalanceData && _accountBalanceData.isACHAuthorizationRequired) {
            return _accountBalanceData.isACHAuthorizationRequired();
          }
          return false;
        },
        //  TODO: Remove this for PROD, only using this
        //  to dynamically configure the prototyep version
        set achExpired(p) {
          _paymentPending = p;
        },

        set guestTokenID(tokenID) {
          _guestTokenID;
        },


        //  List of User's phone numbers on record
        get phones() {
          if (_patientData && _patientData.hasOwnProperty("getPatientPrimaryAddress")) {
            return _patientData.getFirstPhoneNo();
          }
          return false;
        },

        // Primary address on file
        get primaryAddress() {
          if (_patientData && _patientData.hasOwnProperty("getPatientPrimaryAddress") && _patientData.getPatientPrimaryAddress('Primary Home') && !_.isEmpty(_patientData.getPatientPrimaryAddress('Primary Home'))) {
            return _patientData.getPatientPrimaryAddress('Primary Home');
          }
          return false;
        },

        //  All Available Payment History
        // get paymentHistory() {
        //   return _paymentHistoryData;
        // },

        // set paymentHistory(p) {
        //   _paymentHistoryData = p;
        // },

        // set pHistoryObj(p) {
        //   _pHistory = p;
        // },

        // get pHistoryObj() {
        //   return _pHistory;
        // },

        //  All Available Payment Methods
        get paymentMethods() {
          return _mopData;
        },

        //  Get number of available refills
        get numRefills() {
          return _numRefills;
        },

        //  Get the User's prescription history
        get rxHistory() {
          return _rxHistoryData;
        },

        //  Return a MOP data object based on Account ID
        getMopById: function (id) {
          var mop = _.find(_mopData, ['paymentMethodId', id]);
          if (mop && !mop.transactionMode) {
            mop.transactionMode = "";
          } else if (mop && mop.transactionMode === 'EDIT') {
            mop.transactionMode = "EDIT";
          } else {
            mop = addDataService.getNewMOP()
          }
          return mop;
        },

        //  TODO: Need actual creation of unique Account ID
        generateMopId: function () {
          return new Date().getTime();
        },
        // getPaymentHistoryInfo: function () {
        //   return _paymentHistory.paymentHistoryInfo;
        // },
        addNewMop: function (account) {
          _mopData.push(account);
          _retrievePaymentInformationError = false;
        },
        updateMop: function (account) {
          var mop = _.find(_mopData, ['paymentMethodId', account.paymentMethodId]);
          if (mop && mop.transactionMode === 'EDIT') {
            _mopData.forEach(function (item, i) {
              if (item.paymentMethodId == account.paymentMethodId) _mopData[i] = account;
            });
          }
          _retrievePaymentInformationError = false;
        },
        updateListMop: function (list) {
          _mopData = angular.copy(list);
          _mopDataService = angular.copy(_mopData);
          if (!list) {
            _retrievePaymentInformationError = true;
          } else {
            _retrievePaymentInformationError = false;
          }
        },
        setRecentPaymentMethodId: function (paymentId) {
          _recentPaymentId = paymentId;
        },
        

        setReferenceId: function(refId) {
          _refId = refId;
        },


        set recentPaymentId(paymentId) {
          _recentPaymentId = paymentId;
        },

        get activeMop() {
          var recurringMopDetails = {};
          var mop = _.find(_mopData, ['activeFlag', "ACTIVE"]);
          if (mop && mop.payment && mop.payment.type && mop.payment.type == "RECURRING") {
            return mop;
          }
          return;
        },
        get resetMOP() {
          _mopData = angular.copy(_mopDataService);
        },

        get referenceId() {
          return _refId;
        },

        //  Initialize the AccountData Service
        //  Hit the following services
        //  - /getPatientInformation
        //  - /getRxHistoryDetails
        //  - /retrieveAccountBalance
        //  - /retrieveFormOfPayment
        init: (function (userType, component, tokenID) {
          _guestTokenID = tokenID;
          componentName = component;


          /** logging **/
          if (log && log.info) {
            log.info(
              loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) +
              loggerServiceHelper.setDescription("component :" + component)
            );
          }
          
          var d = $q.all([
            ABS.getAccBal(onAccountBalanceSuccess, tokenID)
          ]);


          /**
           * sankar 11/22/2016 - ITPR017031 - edit bank info page
           * Added WTS page error tag
           */
          function getPatientInfo(data) {
            /**
             * sankar 02/10/2016 - SMP 009 - getPatientInformation service error
             * Modified page_error tag
             */
            if (data.SERVER_ERROR || (data.apiResponse && data.apiResponse.showError)) {
              var pageError = cvsUtility.getPageError(data, 'NonFatal', 'getPatientInformation');
              var utagObj = {
                page_error: pageError
              };
              webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
              _retrievePatientInformationError = true;
              // logger
              log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("getPatientInformation") + loggerServiceHelper.setStatus("ERROR"));
              return;
            } else if (data.getError() === '') {
              _patientData = data;
              // var eppflow = $cookies.get('epp', { path: '/' });
              // if (eppflow == 'Y') {
              //     window.location.href = window.location.origin + '/FASTPROXY/ngx-payments/#/payments/account-balance';
              // }
              if (data && data.getPatientInfo() && data.getPatientInfo().memberStatus) {
                if (data.getPatientInfo().memberStatus.toUpperCase() == 'INACTIVE') {
                  cvsUtility.setMemberstatus('Unregistered');
                } else if (data.getPatientInfo().memberStatus.toUpperCase() == 'ACTIVE') {
                  cvsUtility.setMemberstatus('Registered');
                }
                var brandingInfos = data.getBrandingInfos();
                CAD.setBrandingInfos(brandingInfos);
  
                // logger
                log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("getPatientInformation") + loggerServiceHelper.setStatus("SUCCESS"));
              }

            } else {
              var pageError = cvsUtility.getPageError(data, 'NonFatal', 'getPatientInformation');
              var utagObj = {
                page_error: pageError
              };
              webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
              _retrievePatientInformationError = true;
              log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("getPatientInformation") + loggerServiceHelper.setStatus("ERROR"));
            }


          };
          /**
           * sankar 11/22/2016 - ITPR017031 - edit bank info page
           * Added WTS page error tag
           */
          function onAccountBalanceSuccess(data) {
            /**
             * sankar 02/10/2016 - SMP 009 - retrieveAccoutBalance service error
             * Modified page_error tag
             */

            if (data.SERVER_ERROR || (data.apiResponse && data.apiResponse.showError || data.apiResponse && data.apiResponse.isViewError)) {
             
              _accountBalanceError = true;
              cvsUtility.genralPostMessage("UPDATE_ACCOUNT_BALANCE", {
                balance: ''
              });
              $rootScope.$broadcast('accountBalanceAvailable', {
                balance: 'Not Available'
              });
              var pageError = cvsUtility.getPageError(data, 'Fatal', 'retrieveAccoutBalance');
              var utagObj = {
                page_error: pageError
              };
              if (data.apiResponse && (data.apiResponse.showError && data.apiResponse.showError.refId) ||
                (data.apiResponse && data.apiResponse.apiMsg || data.apiResponse && data.apiResponse.apiMsg && data.apiResponse.apiMsg.refId)) {
                _refId = data.apiResponse.showError ? data.apiResponse.showError.refId : data.apiResponse.apiMsg && data.apiResponse.apiMsg.refId;
              }
              webAnalytics.webTrendsUtag("LINK", utagObj, undefined);

                   /** logging **/
                  if (log && log.error) {
                    log.error(
                      loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                      loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
                      loggerServiceHelper.setServiceName("retreiveAccountBalance") +
                      loggerServiceHelper.setStatus("ERROR")
                    );
                  }
                   /** logging **/
                  if (log && log.info) {
                    log.info(
                      loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                      loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) +
                      loggerServiceHelper.setServiceName("retreiveAccountBalance")
                    );
                  }

              if (componentName && componentName == "myAccount" && (data.apiResponse && data.apiResponse.apiMsg && data.apiResponse.apiMsg.statusCode &&
                  data.apiResponse.apiMsg.statusCode == "6622")) {
                _hideComponent = true;
                    
                  /** logging **/
                  if (log && log.info) {
                    log.info(
                      loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                      loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
                      loggerServiceHelper.setServiceName("retreiveAccountBalance") +
                      loggerServiceHelper.setStatus("SUCCESS") +
                      loggerServiceHelper.setDescription("CATS PATIENT- MyAccount")
                    );
                  }
              }

              return;
            }

            _accountBalanceData = data;
            var paymentInfo = data.isPaymentPending() ? { balance: 'Payment pending' } : { balance: $filter('currency')(data.getAcBal()) };
            cvsUtility.genralPostMessage("UPDATE_ACCOUNT_BALANCE", paymentInfo);
            $rootScope.$broadcast('accountBalanceAvailable', paymentInfo);
            CAD.setAccountBalance(paymentInfo.balance);
            
                 /** logging **/
                if (log && log.info) {
                  log.info(
                    loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + 
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + 
                    loggerServiceHelper.setServiceName("retreiveAccountBalance") + 
                    loggerServiceHelper.setStatus("SUCCESS") + JSON.stringify(data)
                  );
                  log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + 
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + 
                    loggerServiceHelper.setServiceName("retreiveAccountBalance")
                  );
                }
            if (componentName && (componentName == "myAccount" || componentName == "RFR")) {
               
                /** logging **/
                if (log && log.info) {
                  log.info(
                    loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) +
                    loggerServiceHelper.setServiceName("retreivePaymentMOPInformation")
                  );
                }

              $q.all([
                RFOP.retrieveFormOfPaymentdata(onGetPaymentSuccess, tokenID)
              ]);
            } else if (componentName == "guest") {
                 
                /** logging **/
                if (log && log.info) {
                  log.info(
                    loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) +
                    loggerServiceHelper.setServiceName("retreivePaymentMOPInformation,getPatientInformation,retreiveRXHistory"));
                }

              $q.all([
                RXHDS.getRXHistoryDetails(getRXHistorySuccess, tokenID)
              ]);
              
            } else {
                 /** logging **/
                if (log && log.info) {
                  log.info(
                    loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) +
                    loggerServiceHelper.setServiceName("retreivePaymentMOPInformation,getPatientInformation,retreiveRXHistory")
                  );
                }
             
              $q.all([
                PIS.getPatientInformationData(getPatientInfo, tokenID),
                RXHDS.getRXHistoryDetails(getRXHistorySuccess, tokenID),
                // PHS.getPaymentHistory(onPaymentHistorySuccess, undefined, tokenID),
                RFOP.retrieveFormOfPaymentdata(onGetPaymentSuccess, tokenID)
              ]);

              
            }

          };
          /**
           * sankar 11/22/2016 - ITPR017031 - edit bank info page
           * Added WTS page error tag
           */
          // function onPaymentHistorySuccess(data) {
          //   if (data.SERVER_ERROR || (data.apiResponse && data.apiResponse.showError)) {
          //     /**
          //      * sankar 02/10/2016 - SMP 009 - retrivePaymentHistory service error
          //      * Modified page_error tag
          //      */
          //     var pageError = cvsUtility.getPageError(data, 'NonFatal', 'retrivePaymentHistory');
          //     var utagObj = {
          //       page_error: pageError
          //     };
          //     webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
          //     if (data.apiResponse && data.apiResponse.showError && data.apiResponse.showError.statusCode && (data.apiResponse.showError.statusCode == "3334" || data.apiResponse.showError.statusCode == "6004" || data.apiResponse.showError.statusCode == "6005")) {
                
          //        /** logging **/
          //       if (log && log.info) {
          //         log.info(
          //           loggerServiceHelper.setFlow("paymentHistory") +
          //           loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
          //           loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
          //           loggerServiceHelper.setServiceName("paymentHistory") +
          //           loggerServiceHelper.setStatus("SUCCESS") +
          //           loggerServiceHelper.setDescription("No payment history found for this user.")
          //         );
          //       }

          //     } else {
          //       _paymentHistoryError = true;
          //     }
          //     if (typeof utag != 'undefined') {
          //       /* utag.view({form_field_error: 'SOP:' + $scope.ERROR.ERROR_MSG
          //        });*/
          //     }
          //       /** logging **/
          //       if (log && log.error) {
          //         log.error(
          //           loggerServiceHelper.setFlow("paymentHistory") +
          //           loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
          //           loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
          //           loggerServiceHelper.setServiceName("paymentHistory") +
          //           loggerServiceHelper.setStatus("ERROR")
          //         );
          //       }
          //     return;
          //   }
          //   var isArray = function (a) {
          //     return (!!a) && (a.constructor === Array);
          //   };
          //   _paymentHistoryData = [];
          //   _pHistory = [];
          //   if (!isArray(data.getPaymentHistory().paymentTransactionInfo.transaction)) {
          //     _paymentHistoryData.push(data.getPaymentHistory().paymentTransactionInfo.transaction);
          //     _pHistory.push(data.getPaymentHistory().paymentTransactionInfo.transaction);
          //   } else {
          //     _paymentHistoryData = _.sortBy(data.getPaymentHistory().paymentTransactionInfo.transaction, ["txnDate"]);
          //     _pHistory = _.sortBy(data.getPaymentHistory().paymentTransactionInfo.transaction, ["txnDate"]);
          //   }
          //   _paymentHistory = data.getPaymentHistory();

          //    /** logging **/
          //   if (log && log.info) {
          //     log.info(
          //       loggerServiceHelper.setFlow("paymentHistory") +
          //       loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
          //       loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
          //       loggerServiceHelper.setServiceName("paymentHistory") +
          //       loggerServiceHelper.setStatus("SUCCESS"));
          //   }

          // };
          /**
           * sankar 11/22/2016 - ITPR017031 - edit bank info page
           * Added WTS page error tag
           */
          function onGetPaymentSuccess(data) {

            _retrievePaymentInformationError = false;
            if (data.SERVER_ERROR || (data && data.apiResponse && data.apiResponse.showError)) {


              //  var pageError = cvsUtility.getPageError(data, 'NotFatal', 'retrieveFormOfPayment');
              //  var utagObj = {
              //    page_error: pageError
              //  };
              //  webAnalytics.webTrendsUtag("LINK", utagObj, undefined);

              if ((data && data.apiResponse && data.apiResponse.showError) && data.apiResponse.showError.statusCode == '6006') {
                _retrievePaymentInformationError = false;
              } else {
                if (data.apiResponse && (data.apiResponse.showError && data.apiResponse.showError.refId) ||
                  (data.apiResponse && data.apiResponse.apiMsg || data.apiResponse && data.apiResponse.apiMsg && data.apiResponse.apiMsg.refId)) {
                  _refId = data.apiResponse.showError ? data.apiResponse.showError.refId : data.apiResponse.apiMsg && data.apiResponse.apiMsg.refId;
                }
                _retrievePaymentInformationError = true;
              }
               /** logging **/
              if (log && log.error) {
                log.error(
                  loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
                  loggerServiceHelper.setServiceName("retreivePaymentMOPInformation") +
                  loggerServiceHelper.setStatus("ERROR")
                );
              }
               /** logging **/
              if (log && log.info) {
                log.info(
                  loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) +
                  loggerServiceHelper.setServiceName("retreivePaymentMOPInformation")
                );
              }
              return;
            } else {

              /*if(data && data.apiResponse && data.apiResponse.paymentInfo && data.apiResponse.paymentInfo.paymentDetails && data.apiResponse.paymentInfo.paymentDetails.expiredIndicator){
                _retrieveCardExpiryError = true;
              }*/
              _mopData = data.getPaymentInfos();
              _mopDataService = angular.copy(_mopData);

               /** logging **/
              if (log && log.info) {
                log.info(
                  loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
                  loggerServiceHelper.setServiceName("retreivePaymentMOPInformation") +
                  loggerServiceHelper.setStatus("SUCCESS") +
                  loggerServiceHelper.setDescription("response:moplist " + JSON.stringify(data.getPaymentInfos().length))
                );
              }

              $rootScope.$broadcast('retreiveFormofPaymentServiceCallDone');

            }
          }
          /**
           * sankar 11/22/2016 - ITPR017031 - edit bank info page
           * Added WTS page error tag
           */
          function getRXHistorySuccess(data) {
          
            _numRefills = 0;
            if (data.SERVER_ERROR || (data.apiResponse && data.apiResponse.showError)) {
              /**
               * sankar 02/10/2016 - SMP 009 - getRXHistoryDetails service error
               * Modified page_error tag
               */
              var pageError = cvsUtility.getPageError(data, 'NonFatal', 'getRXHistoryDetails');
              var utagObj = {
                page_error: pageError
              };
              webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
              log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("retreiveRXHistory") + loggerServiceHelper.setStatus("ERROR"));
              log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retreiveRXHistory"));
              return;
            }
            _rxHistoryData = data.getRXHistoryDetails();
            for (var i = 0; i < _rxHistoryData.length; i++) {
              if (_rxHistoryData[i].readyForRefill.toUpperCase() === "Y") {
                _numRefills++;
              }
            }
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("retreiveRXHistory") + loggerServiceHelper.setStatus("SUCCESS"));
          };
          return d;
        })
      };
    }
  ]);